<template>
<div>
      <template>
        <v-btn
        style="display:none;"
          @click.stop = "open()"
          color=""
          class="mygreen"
          dark
          >

            <img class="img" src="/img/icon_plus.svg" style="margin-left: -6px;margin-right:6px;width:22px;" />
          <span>差し戻し理由入力</span></v-btn>
      </template>

    <v-dialog
      v-model="dialog"
      max-width="600px"
    >

      <v-card class="rounded-lg">
        <v-toolbar
          class="mb-9 text-center"
          color="mygreen"
          dark><span class="text-center">差し戻し理由入力</span></v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="text-left" cols="3">差し戻し理由</v-col>
              <v-col cols="9" class="pt-0">
                      <v-textarea
                          outlined
                          rows="4"
                          v-model="rejection"
                          value=""
                        ></v-textarea>
              </v-col>
            </v-row>

          </v-container>
        </v-card-text>

        <v-card-actions class="pb-6">
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            @click="dialog = false">戻る</v-btn>
          <v-btn dark
            color="error"
            @click="sasimodosi()">差し戻し</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>


<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
import {mapGetters} from 'vuex'
/* eslint-disable */



export default {

    props: {
      arr_staff: Array,
    },
    created () {
        console.log('%c created: DialogKyukaSasimodosi.vue', mycolor.created);
    },


    // datas
    data() {
            return {
                strict: false,
                data: {
                    syubetu: '',
                    reason: '',
                    menu_from: '',
                    menu_to: '',
                },

                staff_selected: '',
                syubetu: ['全休', '午前休', '午後休'],
                syubetu_selected: '',
                reason:'',
                rejection:'',

                dialog: false,

                from: '',
                to: '',
            }
    },
    methods: {
/* eslint-disable */
        open(item){
            console.log('%c open()', 'background:pink;');
            console.log('item: ', item);
            console.log(this.is_admin);
            if( this.user.auth==='一般' ){
                this.staff_selected = this.user.id;
                this.strict = true;
            }

            if(item){
                this.staff_selected = item.staff_id;
                this.syubetu_selected = item.syubetu;
                this.from = item.start;
                this.to = item.end;
                this.reason = item.reason;
                this.rejection = item.rejection;
                this.id = item.id;
            }


            this.dialog = true;
        },

        sasimodosi(){
            console.log('sasimodosi()');
            // ... (省略: console.log) ...

            // バリデーション: 差し戻し理由が空っぽじゃないかチェック！
            if (!this.rejection || this.rejection.trim() === '') {
                alert('差し戻し理由を入力してください。');
                return; // 処理中断
            }

            var api = '/kyuka_sasimodosi'; // ★ FastAPIのエンドポイントに合わせる！
            axios.post(api,  {id:this.id, rejection:this.rejection, staff_id: this.staff_selected, start: this.from, end: this.to} )
              .then((res) => {
                console.log(`%c ${api} のレスポンス！`, mycolor.orange);
                console.log(res.data);

                // FastAPI 側で {status: 'OK'} が返ってきたら成功と判断！
                if (res.data && res.data.status === 'OK') {
                    console.log('🎉 差し戻し成功！親にリスト更新の合図を送るぜ！');
                    this.$emit('getkyukalist'); // ★ 親にリスト更新を依頼！
                    this.dialog = false;       // ★ ダイアログを閉じる！
                    // 必要なら、成功メッセージを出す (Snackbar とか使うとクール！)
                    // alert('休暇申請を差し戻しました。');
                    // TODO: 差し戻しメール送信のトリガーは FastAPI 側でやった方がいいかも？

                } else {
                    // FastAPI側で {status: 'NG'} やエラーが返ってきた場合
                    console.error('😭 差し戻し失敗… FastAPI側でエラーだってさ…', res.data ? res.data.msg : '詳細不明');
                    alert('休暇申請の差し戻しに失敗しました。\n' + (res.data && res.data.msg ? res.data.msg : 'サーバーエラーが発生しました。'));
                    // 失敗した場合はダイアログ閉じない方がいいかも？
                }

                // location.reload(); // ← これは削除！

              })
              .catch((error) => {
                console.error('💥 axios 通信エラー！', error);
                alert('休暇申請の差し戻し中に通信エラーが発生しました。');
                // ダイアログは閉じない
              });

        }  // sasimodosi()

/* eslint-disable */
    }, // methods
    computed: {
        ...mapGetters(['user', 'is_admin']),
    },
}
</script>

<style scoped>
/deep/ .v-input__append-inner{
    margin: auto !important;
}
/deep/ .row > div {
/*    height: 70px; */
}
/deep/ .v-list-item__content{
    text-align: left;
}
/deep/ .theme--light.v-input{
    margin-top: -8px;
}
/deep/ .v-select__slot{
    height: 40px;
}
/deep/ .v-dialog > .v-card > .v-card__text{
    padding-bottom: 0px;
}
</style>
